import { w2d2dApiClient } from "../w2d2d-api-client";

export function isIdeaUri(uri: string): boolean {
    const ideaUriPattern = new RegExp(`^${w2d2dApiClient.baseUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}ideas/([^/]+)$`);
    return ideaUriPattern.test(uri);
}


export function extractIdeaId(uri: string): string | null {
    const ideaUriPattern = new RegExp(`^${w2d2dApiClient.baseUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}ideas/([^/]+)$`);
    const match = uri.match(ideaUriPattern);
    return match ? match[1] : null;
}

export function getPodNameFromUri(uri: string): string | null {
    try {
        const url = new URL(uri)
        const parts = url.pathname.split('/')
        // parts[0] is empty string because pathname starts with /
        // parts[1] is podName
        if (parts.length >= 2) {
            return parts[1]
        }
        return null
    } catch (e) {
        return null
    }
}
